import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Sort } from "@angular/material/sort";
import { SaveService } from "../../../services/save.service";
import { DefaultValuesService } from "../../../services/defaultvalues.service";
import { CustomDialogService } from "../../../services/customdialog.service";
import { Utils } from "../../../utils/utils";
import { LogsHistoryPopupComponent } from "../logshistorypopup/logshistorypopup.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "provisioningtemplate-list",
    templateUrl: './provisioningratemplate-list.component.html',
    styleUrls: ['./provisioningratemplate-list.component.less'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*' })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ],
    standalone: false
})

export class ProvisioningTemplateListComponent implements OnInit {
    @Input('list') list: any[] = [];
    @Input('isEditableMethod') isEditable: any
    @Output() onReload = new EventEmitter<any>();

    columnsToDisplay = ['CommandId', 'CommandName', 'Category', 'Description', 'FirstActivationUtc', 'LastChangeUtc', 'actions'];
    dateColumns = ['FirstActivationUtc', 'LastChangeUtc']
    showTable = false;


    @ViewChild(MatTable, { static: true }) table!: MatTable<any>;

    public dataSource = new MatTableDataSource<any>();

    subscriptionTenant: any;
    lastSort: Sort = {active: '', direction: ''};

    constructor(private activatedRoute: ActivatedRoute
        , private readonly router: Router
        , private readonly http: HttpClient
        , private readonly saveService: SaveService
        , public defaults: DefaultValuesService
        , private readonly customDialog: CustomDialogService
        , @Inject('BASE_URL') private baseUrl: string
        , private readonly changeDetectorRefs: ChangeDetectorRef
        , private readonly dialog: MatDialog
    ) {
    }
    
    openLogsHistory() {
        this.dialog.open(LogsHistoryPopupComponent, {
            width: '80vw',
            maxHeight: '90vh',
            data: { 
                section: 'provisioningtemplate',
                tenantId: this.defaults.tenant,
                controllerTypeId: this.defaults.controllertype.ControllerTypeID
            }
        });
    }
    
    ngOnChanges() {
        this.dataSource.data = [];
        this.dataSource.data = this.list
        this.refreshTable();
    }

    ngOnInit() {
        this.getHeader();
        this.subscriptionTenant = this.defaults.tenantMessageChanges$.subscribe(() => {
            this.getHeader()
        });
        this.saveService.addListener(this);
    }

    ngOnDestroy() {
        this.subscriptionTenant.unsubscribe();
    }

    getHeader() {
            this.columnsToDisplay = ['CommandId', 'CommandName', 'Category', 'Description', 'FirstActivationUtc', 'LastChangeUtc', 'actions'];
    }

    getInput(data: CommandConfigControllerType, property: string): any {
        return data[property];
    }

    getDataType(property: string) {
        let result = ''
        if (this.dateColumns.indexOf(property) > -1) result = 'date'
        else result = 'string'
        return result
    }

    changeElement(object: any, type: string, value: boolean) {
        this.http
            .post<any>(
                this.baseUrl + Utils.getRemoteActionAPI() + 'commandconfigtemplate' + '/' + object.CommandId + '/' + value, {}
            ).subscribe((res) => {
                this.onReload.emit(res);
            }, (error: {
                error: { message: any }
            }) => {
                this.customDialog.openDisplayInfoDialog({ title: 'Error', message: error.error.message });
            });
    }
    getCommandLabel(data) {
        var transl = data['CommandLabel']
        return transl ? transl : data['CommandLabelRef'];
    }
    sortData(sort: Sort) {
        const data = this.dataSource.data.slice();

        // Cycle: default -> asc -> desc -> default
        if (
            this.lastSort.active === sort.active &&
            this.lastSort.direction === sort.direction
        ) {
            // If user clicks again, reset to default
            sort = {active: '', direction: ''};
        }
        this.lastSort = {...sort};

        if (!sort.active || sort.direction === '') {
            // Default: enabled first, then disabled
            this.dataSource.data = data.sort((a, b) => {
                const aEnabled = !!a.IsEnabled;
                const bEnabled = !!b.IsEnabled;
                if (aEnabled !== bEnabled) {
                return aEnabled ? -1 : 1;
                }
                if (a.CommandId < b.CommandId) return -1;
                if (a.CommandId > b.CommandId) return 1;
                return 0;
            });
            return;
        }

        this.dataSource.data = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'CommandId':
                    return this.compare(a.CommandId, b.CommandId, isAsc);
                case 'CommandName':
                    return this.compare(
                        this.getCommandLabel(a)?.toUpperCase() || '',
                        this.getCommandLabel(b)?.toUpperCase() || '',
                        isAsc
                    );
                    case 'Category':
                        return this.compare(
                            (a['Category'] ?? '').toUpperCase(),
                            (b['Category'] ?? '').toUpperCase(),
                            isAsc
                        );
                default:
                    return 0;
            }
        });
    }

    compare(a: number | string, b: number | string, isAsc: boolean) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

    refreshTable() {
        this.showTable = false;
        setTimeout(() => {
            this.dataSource.data = [...this.list];
            this.showTable = true;
        }, 0);
    }
}